import { Box, CircularProgress, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { spotifyGetCurrentToken } from "../../api";
import Config from "../../config";

interface IProps {
  onNewToken: (accessToken: string, expiresIn: number) => void;
}

const SpotifyAuthorization: React.FC<IProps> = ({ onNewToken }) => {
  const navigate = useNavigate();
  const { search } = window.location;
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const params = new URLSearchParams(search.substr(1));
    const authenticated = params.get("authenticated");

    if (authenticated === "true") {
      // User just completed OAuth, fetch token from session
      setIsLoading(true);
      spotifyGetCurrentToken(null)
        .then(response => {
          if (response && response.access_token && response.expires_at) {
            onNewToken(response.access_token, response.expires_at);
            navigate("/");
          } else {
            console.error("Invalid response from token endpoint:", response);
            setError("Failed to retrieve session");
          }
        })
        .catch(err => {
          console.error("Token fetch error:", err);
          setError("Authentication failed");
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  }, [search, onNewToken, navigate]);

  let message = <></>;

  if (search === "") {
    // No token in URL, redirect user to request for one
    window.location.href = Config.api.root + Config.api.spotify_authentication_route;
    message = (
      <>
        <Box mb={2}>
          <Typography variant="subtitle1">Redirecting to Spotify</Typography>
        </Box>
        <CircularProgress size={30} />
      </>
    );
  } else if (isLoading) {
    message = (
      <>
        <Box mb={2}>
          <Typography variant="subtitle1">Completing authentication</Typography>
        </Box>
        <CircularProgress size={30} />
      </>
    );
  } else if (error) {
    message = (
      <Typography variant="subtitle1" color="error">
        {error}
      </Typography>
    );
  } else {
    message = <Typography variant="subtitle1">Processing...</Typography>;
  }

  return (
    <>
      <Typography variant="h4" align="center">
        Spotify Authorization
      </Typography>
      <Box alignItems="center" textAlign="center">
        {message}
      </Box>
    </>
  );
};

export default SpotifyAuthorization;
